import $ from 'jquery';

const $window = $(window);

function resizeHeader() {
    let distanceToTop = $window.scrollTop();
    if (distanceToTop > 0) {
        $('.header').addClass('flatter');
    } else {
        $('.header').removeClass('flatter');
    }
}

$(function () {
    resizeHeader();
    $window.on('scroll', resizeHeader);
});
